module.exports = __webpack_public_path__ + "img/trade-icon-2.f2bd82e3.svg";